import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReceivablesJob} from "../../../../shared/interface/receivables-job";
import {interval, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {ReceivablesImport} from "../../../../shared/interface/receivables-import";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {ReceivablesImportsService} from "../../../../shared/services/receivables-imports.service";
import {ReceivablesJobService} from "../../../../shared/services/receivables-job.service";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import moment from "moment/moment";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-receivables-job-list',
  templateUrl: './receivables-job-list.component.html',
  styleUrls: ['./receivables-job-list.component.scss']
})
export class ReceivablesJobListComponent implements AfterViewInit, OnInit, OnDestroy  {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  jobs: ReceivablesJob[] = [];
  displayedColumns: string[] = ['parameters', 'createdAt', 'createdBy', 'result', 'status'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  importListSubject: ReplaySubject<CountedAndPaginated<ReceivablesImport>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesImport>>(1);
  ofwcaControl: FormControl;
  importControl: FormControl;
  partnerControl: FormControl;
  insuranceCompanyControl: FormControl;
  formErrors = {};
  errors: any = {};
  actionForm: FormGroup;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesJobService: ReceivablesJobService,
    private receivablesImportService: ReceivablesImportsService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesJobService.jobListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<ReceivablesJob>) => {
          this.jobs = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();

    this.actionForm = fb.group({
      insuranceCompany: this.insuranceCompanyControl = fb.control(''),
      receivablesImport: this.importControl = fb.control('', [Validators.required]),
      ofwca: this.ofwcaControl = fb.control(''),
      partner: this.partnerControl = fb.control(''),
    });
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }

  ngOnInit(): void {
    interval(1000)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.paginator.pageIndex === 0) {
          this.loadListData();
        }
      });
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.buildFilters()
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;

        this.loadListData();
      })
    ;
    this.insuranceCompanyControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        this.importControl.reset();
        if (data) {
          this.receivablesImportService.loadImportList(
            0, 1000, {insuranceCompany: data, disable: false }, this.importListSubject
          );
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }

  loadListData(): void {
    this.receivablesJobService.loadJobList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
  make(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesJobService.generate(this.actionForm.value)
          .subscribe(() => {
            this.loadListData();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Blokada uruchomienia akcji', error.status.toString(), {duration: 2000});
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      }
    });
  }
}
